var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "multi_column", style: _vm.cssVars }, [
    _c("div", { staticClass: "container" }, [
      _vm.title
        ? _c("h2", {
            staticClass: "col-title",
            class: _vm.text_alignment,
            domProps: { innerHTML: _vm._s(_vm.title) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "multi_column__inner",
          class: {
            one: _vm.parsedCtas.length === 1,
            two: _vm.parsedCtas.length === 2,
            three: _vm.parsedCtas.length === 3,
            four: _vm.parsedCtas.length === 4,
          },
        },
        _vm._l(_vm.parsedCtas, function (cta, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "multi_column__inner__text",
              style: {
                "--background-colour": cta.background_colour,
                "--text-colour": cta.text_colour,
                "--title-colour": cta.title_colour,
                "--tile-border":
                  cta.background_colour === "#fff" ? "1px" : "0px",
              },
              attrs: {
                "data-aos": "fade-up",
                "data-aos-duration": "300",
                "data-aos-offset": 50,
                "data-aos-delay": index * 50,
              },
            },
            [
              cta.image
                ? _c("div", { staticClass: "image" }, [
                    _c("img", { attrs: { src: cta.image.url } }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content_container",
                  class: {
                    "has-cta": cta.primary_button || cta.secondary_button,
                  },
                },
                [
                  cta.title
                    ? _c("h3", { domProps: { innerHTML: _vm._s(cta.title) } })
                    : _vm._e(),
                  _vm._v(" "),
                  cta.text
                    ? _c("div", {
                        staticClass: "text",
                        domProps: { innerHTML: _vm._s(cta.text) },
                      })
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              cta.primary_button || cta.secondary_button
                ? _c(
                    "div",
                    { staticClass: "cta_container" },
                    [
                      cta.primary_button
                        ? _c("primary-button", {
                            attrs: {
                              link: cta.primary_button,
                              label: cta.primary_button.title,
                              theme: cta.cta_theme,
                              type: "cta",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      cta.secondary_button
                        ? _c("tertiary-button", {
                            attrs: {
                              link: cta.secondary_button,
                              label: cta.secondary_button.title,
                              theme: cta.cta_theme,
                              type: "cta",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }